import React from 'react'
import './Account.scss'

import discord from '../../Images/discordpfp.png'

function Account() {
  return (
    <div className='dashContainer'>
        <div className='containerHeader'>
            <h1>Account</h1>
        </div>

        <div className='accountGrid'>
            <img src={discord} alt="discord" className='discordpfp' />
            <div className='discordInfo'>
                <h2>Jefle#0001</h2>
                <a href="" className='btn buttonLogout text-nowrap'>Log Out</a>
            </div>
        </div>
        <div className='joinDiscord'>
          <a href="" className='btn buttonDiscord text-nowrap'>Join Discord</a>
        </div>
    </div>
  )
}

export default Account